import {
  renderLocationChoice,
  renderLocationInOrNear,
} from '../../../common/components/SearchHeader/types/LocationChoice';
import { getDayTerm } from '../renderers';
import { SeoScenario } from '../types';

export const bulkBillingGpScenario: SeoScenario = it => {
  const location = renderLocationChoice(it.location);
  const inOrNear = renderLocationInOrNear(it.location);

  return {
    pageTitle: `Find a Bulk Billing GP ${inOrNear} ${location}`,
    visualHeader: `Find a Bulk Billing GP ${inOrNear} ${location}`,
    metaDescription: `Find a Bulk Billing GP ${inOrNear} ${location}. Book an Appointment Online or View Opening Hours for Bulk Billing GPs in ${location}, Contact Details & More. Finding a Bulk Billing GP near you in ${location} is easy with Healthengine`,
    textContent: `Finding a bulk billing GP ${inOrNear} ${location} who's right for you is easy with Healthengine. Find comprehensive information on bulk billing doctors and GP clinics available in and around ${location}, including real positive customer feedback, accreditations, contact details, staff profiles, opening hours, pricing and payment info and much more. We connect you with the best bulk billing doctors and GP clinics in ${location} when you need it the most.`,
  };
};

export const bookOnlineBulkBillingGpScenario: SeoScenario = it => {
  const location = renderLocationChoice(it.location);
  const dayTerm = getDayTerm(it);
  const inOrNear = renderLocationInOrNear(it.location);

  return {
    pageTitle: `Book a Bulk Billing GP Appointment ${dayTerm}${inOrNear} ${location}`,
    visualHeader: `Book a Bulk Billing GP Appointment ${inOrNear} ${location}`,
    metaDescription: `Book a Bulk Billing GP Appointment ${dayTerm}${inOrNear} ${location}. See Available Appointments and Book a Bulk Billing GP Appointment Online Instantly with Healthengine`,
    textContent: `Healthengine provides information on any bulk billing GPs in ${location} that you would like to visit, as well as any procedures or treatments that may be on offer at each location. We take the hassle out of finding a bulk billing GP near you by providing comprehensive information on bulk billing GP clinics in and around ${location}, including real positive customer feedback, accreditation, contact details, staff profiles, opening hours, pricing and payment info and much more. If you needed information on a bulk billing GP clinic in ${location} that provides general check ups and flu vaccines, you would be able to see that the bulk billing GP clinic provides these services before you make a booking.`,
  };
};
